<h4 mat-dialog-content>Select {{ selectedProduct.name }} Item</h4>
<mat-dialog-content fxLayout="column">
  <table class="table">
    <thead>
      <tr>
        <th>Code</th>
        <th>Location</th>
        <th>Status</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let item of selectedProduct.items">
        <tr *ngIf="!item.deleted">
          <td>
            <a (click)="openItemDialog(item)">{{ item.code }}</a>
          </td>
          <td>{{ item.location | locationNameFromId | async }}</td>
          <td>
            {{ item.has_current_workshop_jobs ? 'Workshop' : item.status }}
          </td>
          <td>
            <button
              mat-raised-button
              (click)="selectItem(item)"
              *ngIf="
                item.deleted === 0 &&
                item.status !== 'On hire' &&
                item.has_current_workshop_jobs === false
              "
            >
              Add
            </button>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>

  <div
    *ngIf="unavailableItem"
    class="bg-red-300 border-t-4 border-red text-red-700 px-4 py-3 mt-4 mb-4"
    role="alert"
  >
    <p class="font-bold">Warning</p>
    <p class="text-sm">
      {{ unavailableItem.code }} is already on hire,
      <a
        [routerLink]="[
          'product/',
          unavailableItem.product_id,
          { type: 'hire' }
        ]"
      >
        click here</a
      >
      to go to the product page.
    </p>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button type="button" mat-raised-button (click)="close()">Cancel</button>
</mat-dialog-actions>
